module.exports = __webpack_public_path__ + "resources/img/career-welfareImg4.1ae58397.jpg";